var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscoverGoldDeposit = function SvgDiscoverGoldDeposit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.46 13.29h-7.52l-1.097 4.974h9.716L20.46 13.29Zm-.682 3.905a.345.345 0 0 1-.41-.261l-.41-1.871h-2.82a.344.344 0 1 1 0-.69h3.097a.343.343 0 0 1 .337.27l.469 2.142a.345.345 0 0 1-.263.41ZM19.292 20.233l-1.098 4.974h9.716l-1.098-4.974h-7.52Zm6.837 3.907a.346.346 0 0 1-.41-.262l-.41-1.872h-2.82a.344.344 0 1 1 0-.69h3.097a.344.344 0 0 1 .337.271l.47 2.143a.345.345 0 0 1-.264.41ZM6.59 20.233 5.49 25.207h9.716l-1.098-4.974h-7.52Zm6.836 3.907a.346.346 0 0 1-.41-.262l-.41-1.872h-2.82a.344.344 0 1 1 0-.69h3.097a.345.345 0 0 1 .337.271l.47 2.143a.344.344 0 0 1-.264.41Z",
    fill: "#2F5EA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.164 12.186a.343.343 0 0 0 .244-.1l1.426-1.427a.344.344 0 1 0-.488-.488l-1.426 1.427a.345.345 0 0 0 .244.588ZM16.602 9.607a.345.345 0 0 0 .344-.345V7.138a.345.345 0 1 0-.69 0v2.124a.345.345 0 0 0 .346.345ZM9.993 12.085a.344.344 0 1 0 .487-.487L9.054 10.17a.345.345 0 0 0-.487.488l1.426 1.426Z",
    fill: "#D1B896"
  })));
};
export default SvgDiscoverGoldDeposit;